import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledTeacherFocus = styled.div`
  margin: 20px 0 19px 0;
  line-height: 1.25;
  letter-spacing: 0.32px;
  font-weight: normal;

  p {
    margin: 10px 0;
  }

  strong {
    font-weight: 600;
  }

  ul,
  ol {
    margin: 0 0 10px 0;
    padding-inline-start: 20px;
    font-size: 14px;
    line-height: 1.93;
    color: ${COLORS.doveGray};
  }

  li > p {
    line-height: 1.25;
    margin: 0;
  }
`;
